import styled from 'styled-components';
import * as Parent from '../Base/style';

export const ModalWrapper = styled(Parent.ModalWrapper)``;
export const ModalWrapper2 = styled(Parent.ModalWrapper2)``;
export const ParentWrapper = styled(Parent.ParentWrapper)``;
